import { render, staticRenderFns } from "./MoleculeAlertNotification.vue?vue&type=template&id=05a55f70&scoped=true&"
import script from "./MoleculeAlertNotification.vue?vue&type=script&lang=js&"
export * from "./MoleculeAlertNotification.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeAlertNotification.vue?vue&type=style&index=0&id=05a55f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a55f70",
  null
  
)

export default component.exports